






















import { Component, Prop, Vue } from "vue-property-decorator";
import VModal from "@/components/VModal.vue";
import VPercentInput from "@/components/VPercentInput.vue";

@Component({
  components: {
    VModal,
    VPercentInput,
  },
})
export default class MarkupModal extends Vue {
  modal!: VModal;
  private markup = 0;

  mounted() {
    this.modal = this.$refs.modal as VModal;
  }

  get hasContent(): boolean {
    return this.$slots.default != null;
  }

  protected onCancel() {
    this.modal.hide();
  }

  protected onConfirm() {
    this.modal.hide();
    this.$emit("success", this.markup);
  }

  protected onHidden() {
    // this.reset();
  }

  setMarkup(markup: number) {
    this.modal.show();

    if (markup) {
      this.markup = markup;
    }
  }

  reset() {
    this.markup = 0;
  }
}
